function shareCurrentPage() {
  const pageTitle = document.title;
  const pageUrl = window.location.href;

  navigator
    .share({
      title: pageTitle,
      url: pageUrl,
    })
    .catch(console.error);
}
